import React, { Component } from "react";

class FieldTextarea extends Component {
    render() {
        let { fieldConfig, uiSchema } = this.props;

        // custom size
        if ("ui:options" in uiSchema && "size" in uiSchema["ui:options"]) {
            if (uiSchema["ui:options"].size === "medium") {
                fieldConfig.rows = 4;
            }
            if (uiSchema["ui:options"].size === "large") {
                fieldConfig.rows = 8;
            }
        }

        return <textarea {...fieldConfig} />;
    }
}

export default FieldTextarea;



// WEBPACK FOOTER //
// ./src/FieldTextarea.js